module.exports = {"id":"176731","name":"Pontus Wernbloom","rating":"80","photo":"./data/images/photos/4/176731.png","club":{"name":"CSKA Moscou","logo":"./data/images/clubs/CSKAMoscou.png"},"positions":["MDC","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PontusWernbloom0.json
// module id = 3479
// module chunks = 0